module.exports = __webpack_public_path__ + "static/logo_white-b4e43c4073bd03654424c3d522efca68.png";